import { render, staticRenderFns } from "./ModificationIframe.vue?vue&type=template&id=375d2d7c&"
import script from "./ModificationIframe.vue?vue&type=script&lang=ts&"
export * from "./ModificationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports